import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {
    Box, Container, Divider, Grid, IconButton, Typography
} from '@mui/material';

import { formatRange } from '../../../helpers/dateHelper';

import './dashboard.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import Acumulado from './Acumulados/Acumulado';
import AcumuladoCard from './Acumulados/AcumuladoCard';
import DateFilterDialog from './components/DateFilterDialog';
import useDashboardData from './hooks/useDashboardData';
import RegularCustomers from './RegularCustomers/RegularCustomers';
import StateSalesSection from './StateSales/StateSalesSection';
import TicketPromedioComponent from './TicketPromedio/TicketPromedioComponent';
import TopProducts from './TopProducts/TopProducts';
import TopProductsHistory from './TopProducts/TopProductsHistory';
import YearNewClients from './YearNewClients/YearNewClients';

const DashboardComponent = () => {
    const {
        today,
        sales,
        topProducts,
        newCustomers,
        stateSales,
        regularCustomers,
        dateFilter,
        averageTicket
    } = useDashboardData();

    const { startDate, endDate } = dateFilter.range;
    const {
        generalTktTable, generalTktGraph,
        clientTktTable, clientTktGraph
    } = averageTicket.current;
    return (
        <div style={{ backgroundColor: '#F3F4F6' }}>
            <Container maxWidth="xl" sx={{ py: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.25, mb: 3 }}>
                    <Typography variant="h5" color="text.secondary" paragraph sx={{ my: 'auto' }}>
                        Dashboard
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <IconButton
                        aria-label="Cambiar rango de fechas"
                        onClick={dateFilter.openDialog}
                        sx={{ p: 0, mr: 2 }}
                    >
                        <CalendarMonthIcon />
                    </IconButton>
                    <Typography variant="body1">
                        {`Fecha establecida: ${formatRange(startDate, endDate)}`}
                    </Typography>
                </Box>

                <Grid container spacing={4} sx={{ mt: 1 }}>
                    <TopProducts
                        today={today}
                        filteredRange={dateFilter.range}
                        dateRanges={dateFilter.ranges}
                        topProductsData={topProducts.data}
                        ensureAnnualData={topProducts.ensureAnnualData}
                    />
                    <AcumuladoCard
                        dateRange={dateFilter.ranges.filtered}
                        dateLabel="Filtrado"
                        icon="fa-sharp fa-solid fa-filter-circle-dollar"
                        totalSales={sales.filtered}
                        exportRange={dateFilter.range}
                        exportFilename="pedidos_ventas_rango-personalizado.csv"
                    />
                </Grid>

                <DateFilterDialog
                    open={dateFilter.dialogOpen}
                    onClose={dateFilter.closeDialog}
                    onApply={dateFilter.applyRange}
                    currentRange={dateFilter.range}
                />

                <Acumulado
                    today={today}
                    dateRanges={dateFilter.ranges}
                    todayTotalData={sales.today}
                    weekTotalData={sales.week}
                    monthTotalData={sales.month}
                    quarterTotalData={sales.quarter}
                    yearToDateTotalData={sales.yearToDate}
                />

                <Box sx={{ mt: 4 }}>
                    <TopProductsHistory
                        products={topProducts.historical}
                        loading={topProducts.historicalLoading}
                    />
                </Box>

                <Divider sx={{ my: 4 }} />

                <YearNewClients
                    firstSemester={newCustomers.firstSemester}
                    secondSemester={newCustomers.secondSemester}
                    totalNewClients={newCustomers.total}
                    customers={newCustomers.customers}
                    today={today}
                />

                <StateSalesSection
                    year={today.getFullYear()}
                    today={today}
                    countrySalesData={stateSales.country}
                    topStatesData={stateSales.topStates}
                />

                <RegularCustomers
                    today={today}
                    fqtMonthlyData={regularCustomers.monthly}
                    fqtQuarterlyData={regularCustomers.quarterly}
                    fqtYearToDateData={regularCustomers.yearToDate}
                />
            </Container>

            <TicketPromedioComponent
                year={averageTicket.year}
                setYear={averageTicket.selectYear}
                averageTicket={averageTicket.data}
                generalTktGraph={generalTktGraph}
                generalTktTable={generalTktTable}
                clientTktGraph={clientTktGraph}
                clientTktTable={clientTktTable}
                orders={averageTicket.orders}
                customers={averageTicket.customers}
                today={today}
            />
        </div>
    );
};

export default DashboardComponent;
